/**
 * @author        tae@zumper.com (Tae Yoon)
 * @copyright     Copyright (c) 2019, Zumper
 * @description   openMultiMessageModal thunk
 */

import { MODAL_TYPE, type NonEmptyMultiMessageModal } from '@zcode/state-type'
import type { Dispatch } from 'redux'
import { trackMultiMessageImpression } from '../../../traktor/thunks/trackMultiMessageImpression'
import { receiveMultiMessageData } from '../../actions/multiMessageModal'
import { openModal } from '../index'

export const openMultiMessageModal = (data: NonEmptyMultiMessageModal) => (dispatch: Dispatch) => {
  const { analyticChannel, entity, origin, similarListings } = data
  const shownPropertyIds = similarListings.map((similar) => similar.uId)
  dispatch(
    trackMultiMessageImpression({
      analyticChannel,
      entity,
      origin,
      shownPropertyIds,
    })
  )

  dispatch(receiveMultiMessageData(data))
  dispatch(openModal(MODAL_TYPE.MULTI_MESSAGE))
}
